// src/components/Dashboard/RecentlyAdded.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {t} from '../../../../lang/index'

interface PacoteRecentDTO {
  id: number;
  titulo: string;
  fotoUrl: string | null;
  servicoNome: string;
  bookingsCount: number;
}

const RecentlyAdded: React.FC = () => {
  const [pacotes, setPacotes] = useState<PacoteRecentDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPacotes = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get<PacoteRecentDTO[]>(
          `${process.env.REACT_APP_API_URL}/empresas/dashboard/recently-added`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          }
        );
        setPacotes(res.data);
      } catch (error) {
        console.error("Erro ao buscar pacotes recentes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPacotes();
  }, []);

  if (loading) return <p>Carregando...</p>;

  return (
    <div className="col-xl-6 col-xxl-5 d-flex">
      <div className="card shadow-none flex-fill">
        <div className="card-body">
          <h6 className="mb-4">{t("recentlyadded.titulo")}</h6>
          {pacotes.map((p) => {
            // Monta a URL completa da imagem
            const fotoUrlCompleta = p.fotoUrl
              ? `${process.env.REACT_APP_API_URL}${p.fotoUrl}`
              : "/assets/img/default-pacote.jpg";

            return (
              <div
                key={p.id}
                className="d-flex justify-content-between align-items-center mb-4"
              >
                <div className="d-flex align-items-center">
                  <Link
                    to={`/flight-details/${p.id}`}
                    className="avatar avatar-lg flex-shrink-0 me-2"
                  >
                    <img
                      src={fotoUrlCompleta}
                      className="img-fluid rounded-circle"
                      alt={p.titulo}
                    />
                  </Link>
                  <div>
                    <h6 className="fs-16">
                      <Link to={`/flight-details/${p.id}`}>{p.titulo}</Link>{" "}
                      <span className="badge badge-soft-info badge-xs rounded-pill">
                        <i className="isax isax-signpost me-1" />
                        {p.servicoNome}
                      </span>
                    </h6>
                  </div>
                </div>
                <Link
                  to={`/flight-details/${p.id}`}
                  className="btn rebook-btn btn-sm"
                >
                  {p.bookingsCount} Bookings
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecentlyAdded;